import { Box, Dialog, IconButton, Theme, Typography, useTheme } from "@mui/material"
import BreadCrum from "../../lib/BreadCrum"
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "../../redux-store/reducers";
import { useEffect, useState } from "react";
import { DialogCloseIcon, YellowWarning } from "../../assets/SvgIcons";
import AddBankForm from "./AddBankForm"
import { BankListObj, InvestorList, InvestorListBanksRes } from "../../redux-store/actions/bank";
import { USER_ROLES } from "../../utils/constant";

export default function AddBank(): JSX.Element {
    const theme = useTheme();
    const history = useHistory();
    const { role = "" } = useSelector((state: any) => state.auth);
    const { selectedInvObj: selectedInvestor,isMigrated=false } = history?.location?.state as { selectedInvObj: InvestorList,isMigrated?:boolean };
    const initialRouter = history.location.pathname?.split('/').filter((item) => item !== '')
    const [isNoInvestorDialogVisible, setNoInvestorDialogVisible] = useState<boolean>(false);
    const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio);


    const handleNoInvestorDialogClose = () => {
        setNoInvestorDialogVisible(false)
    }
    const rmRouterPath =
        [
            {
                name: 'Dashboard',
                path: '/dashboard',
                warning: false
            },
            {
                name: 'Add Bank',
                path: `/${initialRouter[0]}`,
            },
        ]

    const investorRouterPath = [
        {
            name: 'Dashboard' + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: '/investor-dashboard',
        },
        {
            name: 'Add Bank',
            path: `/${initialRouter[0]}`,
        },

    ]
    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <BreadCrum array={role === USER_ROLES.RM ? rmRouterPath : investorRouterPath} />
            </Box>
            <Box mb="25px" mt={2}>
                <Typography variant='h1' color="text.primary">
                    Add New Bank
                </Typography>
            </Box>
            <Box
                sx={{
                    p:{xs:"10px",sm:"25px"},
                    bgcolor: "background.paper",
                    boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                    borderRadius: '25px',
                    minHeight: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 195px)' },
                }}>
                {role === USER_ROLES.RM && (
                    <Box sx={{ width: "100%", marginTop: "30px" }}>
                        <Typography variant="h3">Selected Investor*: {selectedInvestor?.customerName ?? "-"}</Typography>
                    </Box>
                )}
                {selectedInvestor && (
                    <>
                        <Box
                            sx={{
                                mt: '20px',
                                p: {xs:"15px",sm:"35px"},
                                bgcolor: "background.paper",
                                boxShadow: `0px 4px 5px 0px ${theme.palette.common.black}0D`,
                                borderRadius: '15px',
                                border: `1px solid ${theme.palette.grey[100]}`,
                            }}>
                            <Box mb={5}>
                                <Typography variant='body_600' color="text.primary">
                                    Add Bank Details
                                </Typography>
                            </Box>
                            <AddBankForm selectedInvestor={selectedInvestor} isMigrated={isMigrated} />
                        </Box>
                    </>
                )}
            </Box >
            <Dialog
                onClose={handleNoInvestorDialogClose}
                open={isNoInvestorDialogVisible}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "22px 24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "8px",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                columnGap: "12px",
                                alignItems: "center"
                            }}
                        >
                            <YellowWarning />
                            <Typography
                                variant="h2"
                                sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
                            >
                                No Investor Found!!
                            </Typography>
                        </Box>
                        <IconButton
                            aria-label="close"
                            onClick={handleNoInvestorDialogClose}
                            sx={{
                                padding: "5px"
                            }}
                        >
                            <DialogCloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </Dialog>
        </>
    )
}